
import React, { useState, useEffect } from 'react';
import { Hero } from './components/Hero';
import { CompetenceSection } from './components/CompetenceSection';
import { Features } from './components/Features';
import { ContentSections } from './components/ContentSections';
import { Footer } from './components/Footer';
import { ProductPreview } from './components/ProductPreview';
import { Waitlist } from './components/Waitlist';
import { GoogleFormSection } from './components/GoogleFormSection';

const App: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="relative min-h-screen">
      {/* Background Decor */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none -z-10">
        <div className="absolute top-0 -left-4 w-72 h-72 bg-purple-500 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob"></div>
        <div className="absolute top-0 -right-4 w-72 h-72 bg-blue-500 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-2000"></div>
        <div className="absolute -bottom-8 left-20 w-72 h-72 bg-emerald-500 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-4000"></div>
      </div>

      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-slate-950/80 backdrop-blur-md py-4 shadow-xl' : 'bg-transparent py-6'}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center">
          <div className="flex items-center space-x-2">
            <div className="w-8 h-8 bg-gradient-to-tr from-indigo-600 to-blue-400 rounded-lg flex items-center justify-center font-bold text-white text-lg">Q</div>
            <span className="text-xl font-bold tracking-tight text-white">Qualle</span>
          </div>
          
          <div className="flex items-center">
            <a 
              href="#waitlist-section" 
              className="px-5 py-2.5 bg-indigo-600 hover:bg-indigo-500 text-white text-sm font-bold rounded-xl transition-all shadow-lg shadow-indigo-600/20 active:scale-95"
            >
              Quero fazer parte
            </a>
          </div>
        </div>
      </nav>

      <main>
        <Hero />
        <CompetenceSection />
        <ProductPreview />
        <Features />
        <ContentSections />
        <Waitlist />
        <GoogleFormSection />
      </main>

      <Footer />
    </div>
  );
};

export default App;
